import React, { Component, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'underscore';

import SkipButton from '../presentational/skip_button.jsx';
import { Button } from '../presentational/button.jsx';

import { LoadingCircular, LoadingLinear } from '../presentational/loading.jsx';


export const SiteSurveyDataLoading = ({strings, loadedImagesCount, totalImageCount, canceledImagesCount, 
  cancelImageUpload, retryImageUpload, onSurveyLoad, onImageLoad, imageUploadFailed, skipImageUpload
  }) => {

  const [imageSkip, setImageSkip] = useState(false)

  let text = `${loadedImagesCount}/${totalImageCount} ${strings.FormLoading.imagesLoaded}`;
  if (totalImageCount == 0)
    text = strings.FormLoading.sendingForm;
  
  const LoadingViewer = (text, loadingCondition, failCondition) => {

    if(failCondition){
      return(
        <div className="progress-view">
          <div className="progress-view-title">{text}</div>
          <div className="">{strings.Common.error}</div>
        </div>
      )
    }

    return (
      <div className="progress-view">
          <div className="progress-view-title">{text}</div> 
          {loadingCondition ? <LoadingLinear/> : <div className="ok-icon"></div>}
      </div>
    )
  }

  const skipImageAction = () => {
    setImageSkip(true)
    skipImageUpload()
  }

  return(
    <div className="image-loading">
      <h1>{strings.FormLoading.sendingData}</h1>
      <div className="content">
        
        {LoadingViewer(strings.FormLoading.SendingSurvey, onSurveyLoad)}
        {totalImageCount > 0 && LoadingViewer(`${strings.FormLoading.sendingImages} ${loadedImagesCount}/${totalImageCount}`, onImageLoad, imageUploadFailed) }
       
        {onImageLoad && !onSurveyLoad &&
          <>
          <div className="progress-title"></div>
          <SkipButton
            buttonText={strings.FormLoading.skip}
            confirmText={strings.FormLoading.confirm}
            cancelText={strings.FormLoading.cancel}
            title={strings.FormLoading.modalTitle}
            onConfirm={cancelImageUpload}
            onCancel={() => {}}
            disabled={false}
          />
          </>
        }
        {!onSurveyLoad && !onImageLoad && imageUploadFailed && !imageSkip &&
          <>
          <div className="skip-modal-button">
            <button className={"standard-btn"} id="retryImageUpload" onClick={ () => retryImageUpload() }>
              {strings.FormLoading.retryImageUpload}
            </button>
          </div>
          <SkipButton
            buttonText={strings.FormLoading.skip}
            confirmText={strings.FormLoading.confirm}
            cancelText={strings.FormLoading.cancel}
            title={strings.FormLoading.modalTitle}
            onConfirm={skipImageAction}
            onCancel={() => {}}
            disabled={false}
          />
          </>
        }

      </div>
    </div>
  );
};

function mapDispatchToProps(dispatch){
  return bindActionCreators({}, dispatch);
}

export default connect(null, mapDispatchToProps)(SiteSurveyDataLoading);
